/**
 * Debug page for walkthrough viewer
 * @module
 */
import { createFileRoute } from "@tanstack/react-router";
import { ensureDefined } from "common/utils/assertOfType";
import type { Walkthrough } from "gfx/walkthrough";
import { startingWalkthrough } from "gfx/walkthrough";
import { useShowroomBuilderData } from "lib/components/showroom2/data/useShowroomPlanData";
import ShowroomPhotorealDemo from "lib/components/showroom2/pages/ShowroomPhotorealDemo";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { walkthroughStartSceneFromUrlParams } from "lib/components/walkthrough/walkthroughStartSceneFromUrlParams";
import styles from "lib/components/walkthrough/WalkthroughViewer.module.scss";
import { useEffect, useState } from "react";
import withAuthentication from "../../components/withAuthentication";

function WalkthroughDebug() {
  const [walkthrough, setWalkthrough] = useState<Walkthrough>();

  const builderData = useShowroomBuilderData();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    walkthroughStartSceneFromUrlParams(startingWalkthrough);
    setWalkthrough(startingWalkthrough);
  }, []);

  function loadWalkthrough() {
    const fileDialog = document.createElement("input");
    fileDialog.type = "file";

    fileDialog.onchange = (e: Event) => {
      const target = e.target as HTMLInputElement;

      if (!target.files || target.files.length === 0) {
        return;
      }

      const reader = new FileReader();
      reader.onload = async (e) => {
        const walkthroughJson = ensureDefined(e.target).result as string;
        setWalkthrough(JSON.parse(walkthroughJson));
      };

      reader.readAsText(target.files[0]);
    };

    fileDialog.click();
  }
  return (
    <ShowroomProvider>
      <ShowroomPhotorealDemo
        walkthrough={walkthrough}
        setWalkthrough={setWalkthrough}
        builderData={builderData ?? undefined}
        logHotspotClickAngles
        validateMinimap
        validateLinks
      >
        <header id="menuBar" className={styles.walkthroughViewerMenuBar}>
          <button onClick={loadWalkthrough}>Load walkthrough</button>
        </header>
      </ShowroomPhotorealDemo>
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/debug/walkthrough")({
  component: withAuthentication(WalkthroughDebug, { superAdmin: true }),
});
